import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/quality',
  component: layout,
  meta: {
    funcID: 'F0008',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'iqcInspectionReport',
      name: `${pre}iqcInspectionReport`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000802',
        PID: 'F00',
      },
      component: () => import('@/views/factory/quality/iqcInspectionReport'),
    },
    {
      path: 'iqcInspectionReport/:pageType/:code?',
      name: `${pre}iqcInspectionReport-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { inspectionNo = '' } = $route.query || {}
          return `辅料检验报告 | ${inspectionNo || 'New'}`
        },
        funcID: 'F000802',
        PID: 'F00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },

      component: () =>
        import('@/views/factory/quality/iqcInspectionReport/detail'),
    },
    {
      path: 'fabricInspectionReport',
      name: `${pre}fabricInspectionReport`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000803',
        PID: 'F00',
      },
      component: () => import('@/views/factory/quality/fabricInspectionReport'),
    },
    {
      path: 'fabricInspectionReport/:pageType/:code?',
      name: `${pre}fabricInspectionReport-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { inspectionNo = '' } = $route.query || {}
          return `面料检验报告 | ${inspectionNo || 'New'}`
        },
        funcID: 'F000803',
        PID: 'F00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },

      component: () =>
        import('@/views/factory/quality/fabricInspectionReport/detail'),
    },
    {
      path: 'fabricIssues',
      name: `${pre}fabricIssues`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000809',
        PID: 'F00',
      },
      component: () => import('@/views/factory/quality/fabricIssues'),
    },
    {
      path: 'inspection-aql',
      name: `${pre}inspection-aql`,
      meta: {
        ...meta,
        funcID: 'F000810',
        PID: 'F00',
      },
      component: () => import('@/views/factory/quality/inspection-aql'),
    },
    {
      path: 'production-inspection',
      name: `${pre}production-inspection`,
      meta: { ...meta, PID: 'F00', funcID: 'F000811' },
      component: () => import('@/views/factory/quality/production-inspection'),
    },
    {
      path: 'production-inspection/:pageType/:pendingGoodsInspectionCode?',
      name: `${pre}production-inspection-detail`,
      meta: {
        ...meta,
        PID: 'F00',
        funcID: 'F000811',
        title: ({ $route, menu }) => {
          const pendingGoodsInspectionNo = $route.query.pendingGoodsInspectionNo
          return [menu?.title, pendingGoodsInspectionNo || 'New'].join(' | ')
        },
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/factory/quality/production-inspection/detail'),
    },
    {
      path: 'packaging-inspection',
      name: `${pre}packaging-inspection`,
      meta: { ...meta, PID: 'F00', funcID: 'F000812' },
      component: () => import('@/views/factory/quality/packaging-inspection'),
    },
    {
      path: 'packaging-inspection/:pageType/:pendingGoodsInspectionCode?',
      name: `${pre}packaging-inspection-detail`,
      meta: {
        ...meta,
        PID: 'F00',
        funcID: 'F000812',
        title: ({ $route, menu }) => {
          const pendingGoodsInspectionNo = $route.query.pendingGoodsInspectionNo
          return [menu?.title, pendingGoodsInspectionNo || 'New'].join(' | ')
        },
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/factory/quality/packaging-inspection/detail'),
    },
  ])('quality-'),
}
